import { render, staticRenderFns } from "./coupon-record.vue?vue&type=template&id=067d41da&scoped=true"
import script from "./coupon-record.vue?vue&type=script&lang=js"
export * from "./coupon-record.vue?vue&type=script&lang=js"
import style0 from "./coupon-record.vue?vue&type=style&index=0&id=067d41da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d41da",
  null
  
)

export default component.exports